import React from 'react';

import { IdelinkAppWrapper } from '../../xlink/components/AppWrapper/IdelinkAppWrapper';
import { getApiRoute } from '../../xlink/configs/ApiRoutesMap';
import {
	LoginMethod,
} from '../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/AuthenticationConstants';
import { browserHistory } from '../../libs/IdeLink.Web.Common/src/redux/BrowserHistory';
import { OffersModule } from '../../xlink/modules/Offers/OffersModule';
import { AppRouter } from '../../xlink/routes/AppRouter';
import { OxylinkContextWrapper } from './Configs/OxylinkConfigs';
import { OxylinkRoutes } from './Configs/OxylinkRoutes';
import { OxylinkI18n } from './Locales/OxylinkI18n';
import { OxylinkConstants } from './OxylinkConstants';
import { OxylinkSetup } from './OxylinkSetup';

const OxylinkApp = () => {
	OxylinkSetup.initialize();

	return (
		<IdelinkAppWrapper
			authStorageKey={OxylinkConstants.OXYLINK_AUTH_STORAGE_KEY}
			loginMethod={LoginMethod.LOGIN_METHOD_USERNAME}
			I18n={OxylinkI18n.getI18State()}
		>
			<OxylinkContextWrapper>
				<AppRouter
					routerHistory={browserHistory}
					routes={OxylinkRoutes.getRoutes()}
					defaultRoute={getApiRoute(OffersModule.PACKAGED_ORDERS_API_ROUTE_KEY)}
				/>
			</OxylinkContextWrapper>
		</IdelinkAppWrapper>
	);
};

export default OxylinkApp;
